const ThreadPrefixes = ({thread}) => {
	if (thread.prefixes) {
		return (
			<span className="flex items-center justify-center gap-x-1 md:mb-1">
				{Object.values(thread.prefixes).map((prefix, i) => (
					<span key={i}
					      className={`text-[11px] font-light text-white whitespace-nowrap line-clamp-1 bg-primary px-1 py-0.5 rounded ${prefix.css_class} md:text-xs`}>
						{prefix.title}
					</span>
				))}
			</span>
		);
	}
}

export default ThreadPrefixes;